module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"detail":"자세히","buy_now":"지금 구매하기"}}')
  delete Component.options._Ctor
}
